import { Injectable } from '@angular/core';
import { User } from '../../pages/user/models/user.model';
import {
  ORGANIZACAO_ATIVA_KEY,
  resolveOrganizacaoAtiva,
} from '../../pages/user/services/local-storage.service';

declare const gtag: Function;

@Injectable({
  providedIn: 'root',
})
export abstract class GoogleAnalyticsService {
  constructor() {}

  trackPageView(page_title: string, page_path?: string): void {
    gtag('event', 'page_view', {
      page_title,
      page_path,
    });
  }

  trackPageViewByUser(page_path: string, user?: User): void {
    const organizacao = resolveOrganizacaoAtiva(
      user,
      window.localStorage.getItem(ORGANIZACAO_ATIVA_KEY)
    );

    gtag('event', 'user_page_view', {
      page_path,
      user_id: user ? user.id : null,
      user_name: user ? user.name : null,
      user_email: user ? user.email : null,
      organization_id: organizacao?.id ?? null,
      organization_name: organizacao?.name ?? null,
      date: new Date().toUTCString(),
    });
  }
}
